function Header1Desktop({ children }: any) {
  return (
    <div className="text-custom-white tracking-[0.020em] font-semibold text-[26px] mb-6 mt-12">
      {children}
    </div>
  );
}

export default Header1Desktop;


